/**
 * Local / offline Wavedash SDK stub.
 * On wavedash.com the real SDK is injected; in Vite we provide the same surface
 * the game probes via window.Wavedash.
 */
export function installWavedashStub() {
  if (typeof window === "undefined") return;
  if (window.Wavedash) return window.Wavedash;

  const stub = {
    init() {
      console.info("[wavedash-stub] init");
      return true;
    },
    loadComplete() {},
    updateLoadProgressZeroToOne(v) {
      console.debug("[wavedash-stub] progress", v);
    },
    getUser() {
      return { username: "local" };
    },
    getUsername() {
      return "local";
    },
    updateUserPresence() {
      return Promise.resolve();
    },
    async toggleFullscreen() {
      if (document.fullscreenElement) await document.exitFullscreen();
      else await document.documentElement.requestFullscreen();
    },
    toggleMute() {
      return false;
    },
    writeLocalFile() {
      return Promise.resolve(false);
    },
    createUGCItem() {
      return Promise.resolve({ success: false });
    },
    UGCType: { SCREENSHOT: 0 },
    UGCVisibility: { PUBLIC: 0 },
  };

  window.Wavedash = stub;
  return stub;
}
